module.exports = __webpack_public_path__ + "img/qrcode_shangjia.e61a15eb.jpg";